import { authHeader, handleResponse } from '../helpers'

export const itemService = {
  getItems,
  getItem,
  createItem,
  updateItem,
  deleteItem,
  downloadTemplate,
  getItemsTemplate
}

function getItems(eventId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/items/' + eventId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var items = response.items
      return items
    })
}

function getItemsTemplate(eventId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/items/' + eventId + '/template',
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var items = response.items
      return items
    })
}

function getItem(itemId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/item/' + itemId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      var item = response
      return item
    })
}

function createItem(itemData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: itemData
  }
  return fetch(process.env.VUE_APP_API_URL + '/item', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var item = response
      return item
    })
}

function updateItem(itemId, itemData) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: itemData
  }
  return fetch(process.env.VUE_APP_API_URL + '/item/' + itemId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      var item = response
      return item
    })
}

function deleteItem(itemId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/item/' + itemId, requestOptions)
    .then((res) => res.text())
    .then((res) => {
      var item = res
      return item
    })
}

function downloadTemplate(hasType) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify({
      hasType: hasType
    })
  }
  return fetch(process.env.VUE_APP_API_URL + '/item/template', requestOptions)
    .then(handleResponse)
    .then((response) => {
      return (
        'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' +
        response
      )
    })
}
